export default "__VITE_ASSET__DItU9nDE__"